<template>
  <div class="chart-box" ref="chartBox">
    <v-chart
      v-if="showChart"
      class="chart"
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
      :option="chartOption"
      ref="map"
      theme="ovilia-green"
      autoresize
    />
  </div>
</template>

<script>
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import "echarts-gl"
import eventMixin from "utils/event/eventMixin.js"
import mapMixins from "./plugin"
export default {
  mixins: [mapMixins, eventMixin],
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object
    }
  },
  name: "cxEarth",
  data() {
    return {
      showChart: true,
      reloadTimmer: null,
      mapPluginName: "",
      chartOption: {},
      eventCallbackList: {
        click: ["HubeiQunyiguanMap1.clickCity"]
      }
    }
  },
  watch: {
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "map")
    },
    "options.chartOption.pluginName": {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.clearDom()
        this.initOpt()
      }
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.map?.setOption(this.getOption)
      } else {
        this.$refs.map?.clear()
      }
    }
  },
  computed: {
    //  获取图表的样式
    getOption() {
      return this.options
    },
    getChartStyle() {
      if (this.getOption) {
        return {
          // height: this.getOption.height + "px",
          transform: "rotate(" + this.getOption.rotate + "deg)"
        }
      } else return null
    },

    getDragStatus() {
      return this.$store.state.states.dragStatus
    }
  },
  methods: {
    clearDom() {
      this.$nextTick(() => {
        const childEl = this.$el.childNodes
        for (const child of childEl) {
          if (child.className && !child.className.includes("echarts")) {
            this.$el.removeChild(child)
          }
        }
      })

      // for (const iterator of childEl) {
      // }
    },
    async initOpt() {
      const chartOption = { pluginName: this.getOption.chartOption.pluginName }
      await this.initMapPlugins(chartOption)
      this.chartOption = chartOption
      this.reloadChart()
    },
    /**
     * @param {string} eventType eventCallbackBus中对应的事件类型
     * @param {object} event echarts的事件传参
     */
    dispatchEventCallback(eventType, event) {
      this.eventCallbackList[eventType]?.forEach(functionName => {
        //函数名带点，说明是插件事件，需要for循环定位到handle
        if (functionName.includes(".")) {
          //如果没找到 说明当前没有注册了这个插件 就不需要执行
          if (
            functionName.indexOf("eventControl") === 0 ||
            this.chartOption.pluginName.find(item => functionName.includes(item.slice(0, -6)))
          ) {
            let func = undefined
            let nameSplit = functionName.split(".")
            //将eventCallbackList中对应的时间名字符串拆分后，循环寻址到对应的函数，再执行
            nameSplit.some((tempPointer, pointerIndex) => {
              if (pointerIndex === 0) {
                func = this[tempPointer]
              } else {
                func = func[tempPointer]
              }
              //当找不到当前函数指针对应的函数时，说明当前组件没有用当前插件，则直接return true 跳出循环
              if (!func) {
                return true
              }
            })

            if (func) func(event)
          }
        } else {
          //不带点 说明是公共当方法 没在插件里
          this[functionName](event)
        }
      })
    },
    initReRequestChart(timmer, url) {
      if (this.isBigScreenPreview()) {
        this.reloadTimmer = setInterval(() => {
          this.mapPluginName.forEach(name => {
            if (this[name]) {
              this[name](this.getOption, this.$echarts)
            }
          })
        }, (timmer === 0 ? 600 : timmer) * 1000)
      }
    },
    async initMapPlugins(opt) {
      let option = JSON.parse(JSON.stringify(this.getOption))
      option.chartOption = opt
      this.$initPlugin(option.chartOption.pluginName, [option, this.$echarts])
      // this.$initPlugin(option.chartOption.pluginName, option, this.$echarts)
    },
    reloadChart() {
      this.$nextTick(() => {
        this.showChart = false
      })
      setImmediate(() => {
        this.showChart = true
      })
    },
    getDragStatusHandle(newVal, oldVal, type) {
      if (newVal && this.hasProperty(this.chartOption, "tooltip.show")) {
        const temp = JSON.parse(JSON.stringify(this.chartOption))
        temp.tooltip.show = false
        this.$refs[type].setOption(temp, true)
      } else if (!newVal && !this.hasProperty(this.chartOption, "tooltip.show")) {
        this.$refs[type].setOption(this.chartOption, true)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.reloadTimmer)
    this.reloadTimmer = null
  }
}
</script>
<style>
.BMap_cpyCtrl {
  display: none;
}
.BMap_stdMpCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
</style>
<style scoped>
.chart {
  height: 100%;
}
.chart-box {
  height: 100%;
  padding: 20px;
}
</style>
